import Vue from 'vue';
import Vuex from 'vuex';
// import { omit } from 'ramda';
import { GetShareAPI } from '@/api/active';

import { Toast } from 'mint-ui';

Vue.use(Vuex);

// 创建Vuex对象
const store = new Vuex.Store({
  state: {
    // 用户信息
    userInfo: {},
    // 活动数据
    activeInfo: {},
    // 埋点
    logger: null,

    // 弹窗类
    // 登陆弹窗
    isShowLogin: false,
    // 渠道弹窗
    isShowOs: false,
    // 预加载图片
    images: {},
    // 弹窗控制
    popup: {}

  },
  getters: {},
  mutations: {
    // 设置用户信息
    setUserInfo(state, userInfo = {}) {
      state.userInfo = userInfo;
    },
    // 初始化用户信息
    setInitUserInfo(state, userInfo = {}) {
      state.userInfo = Object.assign({}, userInfo);
    },
    // 设置活动信息
    setActiveInfo(state, activeInfo = {}) {
      state.activeInfo = activeInfo;
    },
    // 初始化活动信息
    setInitActiveInfo(state, activeInfo = {}) {
      state.activeInfo = Object.assign({}, activeInfo);
    },
    // 修改登陆弹窗
    changeLoginPopup(state, val) {
      val = val || (!state.isShowLogin);
      state.isShowLogin = val;
    },
    // 修改渠道弹窗
    changeOsPopup(state, val) {
      val = val || (!state.isShowOs);
      state.isShowOs = val;
    },
    // 开启通用弹窗
    openPopup(state, name) {
      state.popup = { ...state.popup, [name]: true };
    },
    // 关闭通用弹窗
    closePopup(state, name) {
      state.popup = { ...state.popup, [name]: false };
    },
    // 设置预加载图片信息
    setImages(state, val) {
      state.images = val || {};
    },
    setLogger(state, logger) {
      state.logger = logger;
    }
  },
  actions: {
    // 获取初始数据
    onInitDataCallback({ state, commit }, response = {}, config = {}) {
      console.log(response);
      const { needAuthorization = true, needAccount = true, needUpdateInfo = true } = config || {};
      // 防止第二次进入 微信底部有一个返回条，造成布局问题

      if (isReloadWindow()) {
        window.location.reload();
        return response;
      }
      // 重定向，去微信/qq授权
      if (Number(response.code) === 302 && needAuthorization) {
        // 暂时关闭
        onAuthorization(response.data);
        return response;
      }
      // 开启登陆弹窗
      if (Number(response.code) === 401 && needAccount) {
        // 暂时关闭
        commit('changeLoginPopup', true);
      }
      // 设置用户信息
      if (Number(response.code) === 200 && needUpdateInfo) {
        const { user_info = {}, activity = {} } = response.data || {};
        console.log('init: ', response);
        commit('setUserInfo', user_info);
        commit('setActiveInfo', activity);
      }

      // 500的错误提示信息
      if ([403, 407, 500].includes(Number(response.code))) {
        Toast({
          message: response.message,
          duration: 2000,
          className: 'toasts'
        });
      }

      return response;
    },
    // 设置分享信息
    setShare({ state, commit }, config) {
      console.log(config);
      const { uri = window.location.href } = config;
      GetShareAPI({ uri }).then(response => {
        const data = response.data;
        const ua = navigator.userAgent.toLowerCase();
        const { link = window.location.href, title, desc, imgUrl, otherConfig } = config;
        const isWeChatBrowser = ua.match(/Micromessenger/i) && ua.match(/Micromessenger/i)[0] === 'micromessenger';
        if (isWeChatBrowser === true) {
          wx.config({ ...data, ...otherConfig });
          wx.ready(function () {
            wx.updateAppMessageShareData({ link, title, desc, imgUrl });
            wx.updateTimelineShareData({ link, title, imgUrl });
            // wx.onMenuShareTimeline({
            //   title: '123', // 分享标题
            //   link: 'www.baidu.com', // 分享链接
            //   imgUrl: 'https://tideng.qingcigame.com/leading/images/pc/official_btn-2756d0f02a.png', // 分享图标
            //   success: function () {
            //     // 用户确认分享后执行的回调函数
            //   },
            //   cancel: function () {
            //     // 用户取消分享后执行的回调函数
            //   }
            // });
          });
        } else { // qq 分享设置
          setShareInfo({
            title: title, // 分享标题
            summary: desc, // 分享内容
            pic: imgUrl, // 分享图片
            url: link, // 分享链接
            // 微信权限验证配置信息，若不在微信传播，可忽略
            WXconfig: {
              appId: data.appId, // 公众号的唯一标识
              timestamp: data.timestamp, // 生成签名的时间戳
              nonceStr: data.nonceStr, // 生成签名的随机串
              signature: data.signature // 签名
            }
          });
        }
      })
        .catch(({ message }) => {
          Toast({ message: message, duration: 1000, className: 'toasts' });
        });
    },
    // 添加埋点信息
    onCount({ state, commit }, params) {
      if (!state.logger) {
        throw new Error('请先配置logger');
      }
      state.logger.sum(params);
    }
  }
});

export default store;

function isReloadWindow() {
  return (event && event.persisted) || (window.performance && (window.performance.navigation && window.performance.navigation.type) === 2);
}

// 页面重定向
function onAuthorization(data = {}) {
  const { qq_url: qqUrl = '', wechat_url: wechatUrl = '' } = data;
  const ua = navigator.userAgent.toLowerCase();
  const isWeChatBrowser = ua.match(/Micromessenger/i) && ua.match(/Micromessenger/i)[0] === 'micromessenger';
  if (isWeChatBrowser === true) {
    window.location.href = `${wechatUrl}?callback=${encodeURIComponent(window.location.href)}`;
  } else {
    window.location.href = `${qqUrl}?callback=${encodeURIComponent(window.location.href)}`;
  }
}


// WEBPACK FOOTER //
// ./src/store/active.js